// extracted by mini-css-extract-plugin
module.exports = {"replacement-part":"styles_replacement-part__AK5rS"};